import border from '../../border';

const custom = (params) => border.hover.custom(params);

export default custom;
